<template lang="pug">
include /mixins
modal-wrapper(
  :info='{}'
  @close='$emit("close")'
)
  paginated-resource-controller(
    :resource="$options.resources[type].resource"
    :parameters="{ ...params }"
    ref='controller'
    :infinity-scroll="true"
    :changeParameters="changeParameters"
    v-slot="{ pagination, changePagination, changeFilters, filters, receive, result, loading }"
  )
    div
      ui-loader(v-if='loading')
      +b.ds-caption--size_3xl-custom.--semibold.H2.main-title.tt-space_mb--4 {{ item ? item.props.button_text : _('Choose a package') }}
      +b.line-h.--light.tt-space_mb--6
      //- +b.ds-caption--size_sm.--regular.--appearance_center-xl.P.tt-space_mb--5 {{ _('Выберите желаемый и удобный для Вас способ упаковывание товара.') }}
      //- +b.g-row--align_center.--justify_between.tt-space_mb--4.tt-space_mt--4
        +b.g-cell.g-cols--6.--6-xl
        //-   +b.tt-tab--bordered_grey.--spaceless.--variant_start.BUTTON(
        //-     @click.prevent='change(true)'
        //-     :class='{ "is-active": withPackage }'
        //-   )
        //-     +e.icon-img
        //-       svg(width='22' height='27' viewBox='0 0 22 27' fill='none' xmlns='http://www.w3.org/2000/svg')
        //-         path(d='M2.65524 4.66835L2.65523 4.6684L1.13523 25.4417C1.13523 25.4417 1.13523 25.4417 1.13523 25.4417C1.12088 25.6377 1.18873 25.8306 1.32248 25.9745H1.32248C1.4562 26.1183 1.64368 26.2 1.84003 26.2H21.0934C21.2957 26.2 21.4883 26.1133 21.6224 25.9619L21.6225 25.9618C21.7565 25.8104 21.8193 25.6087 21.7948 25.4078L19.2615 4.63444C19.2182 4.27991 18.9172 4.01334 18.56 4.01334H16.6733C16.3357 2.00334 14.5849 0.466672 12.48 0.466672C12.0389 0.466672 11.6136 0.535103 11.2134 0.6604C10.8131 0.535103 10.3878 0.466672 9.9467 0.466672C7.84183 0.466672 6.09107 2.00334 5.75339 4.01334H3.36003C2.98976 4.01334 2.68235 4.29913 2.65524 4.66835ZM14.14 4.01334C14.0104 3.24198 13.6729 2.54078 13.1873 1.9694C14.1857 2.22641 14.9735 3.01451 15.2302 4.01334H14.14ZM9.72983 4.01334C9.93622 3.21056 10.486 2.54357 11.2134 2.17938C11.9407 2.54356 12.4905 3.21052 12.6969 4.01334H9.72983ZM8.28668 4.01334H7.19646C7.45325 3.0145 8.24102 2.2264 9.23941 1.9694C8.75377 2.54079 8.41626 3.24197 8.28668 4.01334ZM4.7298 5.42667L6.14642 24.7867H2.60031L4.01682 5.42667H4.7298ZM20.2952 24.7867H7.56354L6.14693 5.42667H17.9343L20.2952 24.7867Z' fill='#DDE2E7' stroke='#DDE2E7' stroke-width='0.4')

        //-     +e.title.P {{ _('С упаковкой') }}
        //- +b.g-cell.g-cols--6.--6-xl
        //-   +b.tt-tab--bordered_grey.--spaceless.--variant_end.BUTTON(
        //-     @click.prevent='change(false)'
        //-     :class='{ "is-active": !withPackage }'
        //-   )
        //-     +e.icon-img
        //-       svg(width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg')
        //-         path(d='M23.2615 6.63444L23.2615 6.63442C23.2182 6.27991 22.9172 6.01334 22.56 6.01334H20.6733C20.3356 4.00334 18.5849 2.46667 16.48 2.46667C16.0389 2.46667 15.6136 2.5351 15.2134 2.6604C14.8131 2.5351 14.3878 2.46667 13.9467 2.46667C11.8418 2.46667 10.0911 4.00334 9.75339 6.01334H7.36002C6.98976 6.01334 6.68235 6.29913 6.65523 6.66835L6.65522 6.6684L5.13523 27.4417C5.13523 27.4417 5.13523 27.4417 5.13523 27.4417C5.12088 27.6376 5.18871 27.8306 5.32244 27.9744H5.32244C5.45616 28.1183 5.64366 28.2 5.84002 28.2H25.0934C25.2957 28.2 25.4883 28.1133 25.6224 27.9619L25.6225 27.9618C25.7565 27.8104 25.8193 27.6087 25.7948 27.4078L23.2615 6.63444ZM18.14 6.01334C18.0104 5.24199 17.6729 4.54078 17.1873 3.9694C18.1857 4.22641 18.9735 5.01451 19.2302 6.01334H18.14ZM13.7298 6.01334C13.9362 5.21056 14.486 4.54357 15.2134 4.17938C15.9407 4.54356 16.4905 5.21052 16.6969 6.01334H13.7298ZM12.2867 6.01334H11.1964C11.4532 5.0145 12.241 4.2264 13.2394 3.9694C12.7538 4.54079 12.4163 5.24197 12.2867 6.01334ZM8.7298 7.42667L10.1464 26.7867H6.6003L8.01682 7.42667H8.7298ZM24.2952 26.7867H11.5635L10.1469 7.42667H21.9343L24.2952 26.7867Z' fill='#DDE2E7' stroke='#DDE2E7' stroke-width='0.4')
        //-         path(d='M2 30L30 2' stroke='#DDE2E7' stroke-width='2' stroke-linecap='round')

        //-     +e.title.P {{ _('Без упаковки') }}
      +b.tt-cart-wrapper.--max-height_md(id="content-view")
          +b.tt-space_pt--2.tt-space_pb--2
            infinite-template-results-collector(
              :pagination="pagination",
              :items="result && result.items",
              :is-new-page="true"
            )
              template(#default="{ items }")
                template(v-if="items")
                  template(v-for='item in items')
                    +b.g-row.--align_stretch.--appearance_spaced
                      template(v-for='object in item.value')
                        +b.g-cell.g-cols--12.--6-md.--4-xl.--3-fhd
                          cart-package(
                            :product='object'
                            @updatePrice="checkPrice"
                          )
            +b.trigger(id="pagination-observer")
      +b.tt-packages-view-bottom
        +b.g-row.--align_center.--justify_between.tt-space_pt--7
          +b.g-cell.g-cols--12.is-disable-xl(v-if="productsCount")
            +b.g-row.--align_center.--justify_end
              +b.g-cell.g-cols--narrow-sm
                +b.tt-packages-sum.tt-space_mb--3
                  +b.ds-caption.--size_3md.--semibold.SPAN {{ ' ' }} {{ getSplittedHtml(productsSumm) }}
          +b.g-cell.g-cols--narrow-sm
            +b.g-row.--align_center.--space_none(v-if="productsCount")
              +b.g-cell.g-cols--narrow-sm.tt-space_mr--8
                +b.tt-packages-count
                  +b.ds-caption.--size_sm.--size_3md-xl.is-visible-xl.tt-space_mr--2.SPAN {{ _('Товарів') }}{{ ':' }}
                  +b.ds-caption.--size_sm.--size_3md-xl.--semibold.SPAN {{ ' ' }} {{ productsCount }} {{ _('шт.') }}
              +b.g-cell.g-cols--narrow-sm.is-visible-xl
                +b.tt-packages-sum
                  +b.ds-caption.--size_3md
                    span {{ _('Сума за обрані товари') }}{{ ':' }}
                    +b.ds-caption.--semibold.SPAN {{ ' ' }} {{ getSplittedHtml(productsSumm) }}
          +b.g-cell.g-cols--narrow-sm
            +b.tt-button.--variant_3.BUTTON.ds-caption--size_2xs.--size_sm-xl(
              @click.prevent='addToCart(result && result.items)'
              :disabled='!productsCount'
            )
              +e.title.P {{ _('Добавить') }}
</template>

<script>
import { mapActions } from 'vuex'

// import analyticCartAdd from '@analytic/add.js'

import {
  AnswerMessage,
} from '@utils/submit'

import { getPackagesList, getSearchFilters } from '@api/store.service'

import CartPackage from '@app/Cart/Variants/Package'
import PackagesViewContent from '@app/Cart/PackagesViewContent'

export default {
  name: 'PackagesList',
  props: { 
    promise: {
      type: Function,
    }, 
    type: {
      type: String,
    }, 
    item: {
      type: Object,
    },
    params: {
      type: Object
    },
  },
  resources: {
    package: { resource: getPackagesList },
    dynamic: { resource: getSearchFilters },
  },
  getPackagesList,
  components: {
    CartPackage,
    PackagesViewContent,
  },
  data() {
    return {
      withPackage: true,
      productsPrices: {},
      productsSumm: 0,
      productsCount: 0,
      isInfinityTemplate: true
    }
  },
  methods: {
    ...mapActions('cart', [
      'changeCart',
    ]),
    paramsHandler() {
      return { category: 'igly,shpritsy'}
    },
    checkPrice(e) {
      if (!e.summ) {
        delete this.productsPrices[e.id]
      }
      else {
        this.productsPrices[e.id] = e
      }
      const totals = Object.values(this.productsPrices).reduce((acc, item) => {
        acc.totalSum += item.summ;
        acc.totalCount += item.count;
        return acc;
      }, { totalSum: 0, totalCount: 0 })
      this.productsSumm = totals.totalSum
      this.productsCount = totals.totalCount
    },
    checkDisabled(items) {
      if (items) {
        const hasQuantity = items.find(e => e.props.quantity)
        console.log(this.withPackage, !(!!hasQuantity && this.withPackage));
        if (this.withPackage) {
          return !(!!hasQuantity && this.withPackage)
        }
        return this.withPackage
      }
      return false
    },
    scroll() {
      const el = document.getElementById('content-view')
      el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    },
    handlePaginate({ offset, limit }, fn) {
      if (this.loading) {
        return
      }
      fn({ limit, offset })
    },


    changeParameters() {},
    async adder(items) {
      this.load = true
      const entities = []
      items.forEach(item => {
        if (!item.props.quantity) return
        const entity = {
          element: {
            id: item.props?.variant ? item.props.variant.id : item.id,
            type: item.props?.variant ? item.props.variant.type : item.type,
          },
          quantity: item.props.quantity,
        }
        entities.push(entity)
      })
      try {
        await this.changeCart({ data: { entities }, retrieve: false }).then(() => {
          // const { brand: { props: { title: brand } }, categories, title: name } = data.element.props.product.props
          // const { price } = data
          // analyticCartAdd(
          //   name, this.id, price, this.amount, brand, categories.map(l => l.props.title)
          // )
        })
        this.promise(true)
        this.load = false
      } catch (e) {
        this.load = false
        const { errors } = await e.json()
        const [error] = errors
        const [first] = error.state.non_field_errors
        const meta = {
          message: {
            header: this._('Максимальна кількость товарів перевищена. Даний товар вже є у кошику'),
            title: first.message,
          },
        }
        AnswerMessage(meta, this)
      }
    },
    async addToCart(items) {
      if (this.withPackage) {
        await this.adder(items)
        this.$emit('close')
        return
      }
      this.promise(true)
      this.$emit('close')
    },
    change(value) {
      this.withPackage = value
      this.$emit('user:type:update', this.withPackage)
    },
  },
}
</script>
